import React from 'react';

const About = () => {
    return (
        <div className="container mx-auto px-4 py-10 max-w-4xl">
            <h1 className="text-4xl font-bold mb-8 text-center">Hakkımızda</h1>
            
            <div className="bg-white shadow-lg rounded-lg p-8">
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                    Kodu Tara, modern şehir hayatının getirdiği iletişim kopukluğunu çözmek ve 
                    ulaşılabilirliği pratik bir hale getirmek amacıyla kurulmuştur. Aracınız park halindeyken, 
                    dükkanınız kapalıyken veya siz uzaktayken bile insanların size kolayca ulaşmasını sağlayan 
                    dijital bir köprü kuruyoruz.
                </p>

                <h2 className="text-2xl font-bold mb-4 text-black">Vizyonumuz</h2>
                <p className="text-gray-700 mb-6">
                    Teknolojinin gücünü kullanarak, günlük hayatı kolaylaştıran, güvenli ve pratik 
                    iletişim çözümleriyle sektörde lider olmak. Her aracın ve işletmenin bir "dijital kimliğe" 
                    sahip olduğu bir gelecek hayal ediyoruz.
                </p>

                <h2 className="text-2xl font-bold mb-4 text-black">Neden Kodu Tara?</h2>
                <ul className="list-disc pl-5 space-y-3 text-gray-700">
                    <li><strong>Gizlilik Odaklı:</strong> Telefon numaranızı herkesle paylaşmak zorunda kalmazsınız.</li>
                    <li><strong>Kolay Kullanım:</strong> Uygulama indirmeye gerek kalmadan, sadece kamera ile çalışır.</li>
                    <li><strong>Her Zaman Ulaşılabilir:</strong> Siz orada olmasanız bile QR kodunuz sizin yerinize konuşur.</li>
                </ul>
            </div>
        </div>
    );
};

export default About;